import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConnectedDialogModule } from '@morningstar/shared/ui-kit/connected-dialog';
import { ReportExplanationIconService } from './report-explanation-icon.service';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';
import { ReportExplanationIconComponent } from './report-explanation-icon.component';
import { ReportExplanationIconDialogComponent } from './report-explanation-icon-dialog/report-explanation-icon-dialog.component';

@NgModule({
  declarations: [
    ReportExplanationIconComponent,
    ReportExplanationIconDialogComponent
  ],
  imports: [
    CommonModule,
    ConnectedDialogModule,
    AngularMaterialModule
  ],
  exports: [
    ReportExplanationIconComponent
  ],
  providers: [
    ReportExplanationIconService
  ],
  entryComponents: [
    ReportExplanationIconDialogComponent
  ]
})
export class ReportExplanationIconModule { }
